import request from '@/utils/request'

/**
 * 角色列表
 * @param {*} data 
 * @returns 
 */
export const getRoleList = (data) =>  request({
    method: 'post',
    url: `/organization/api/role/all`,
    data: data
})

/**
 * 新增角色
 * @param {*} data 
 * @returns 
 */
 export const addRole = (data) =>  request({
    method: 'post',
    url: `/organization/api/role`,
    data: data
})

/**
 * 删除角色
 * @param {*} data 
 * @returns 
 */
 export const deleteRole = (id) =>  request({
    method: 'delete',
    url: `/organization/api/role/${id}`
})

/**
 * 修改角色
 * @param {*} data 
 * @returns 
 */
 export const updateRole = (data) =>  request({
    method: 'put',
    url: `/organization/api/role`,
    data: data
})


/**
 * 角色类别
 * @param {*} data 
 * @returns 
 */
 export const getRoleType = (data) =>  request({
    method: 'get',
    url: `/organization/api/roleType/all`,
    data: data
})

/**
 * 获取省份
 * @param {*} data 
 * @returns 
 */
 export const getProvince = (data) =>  request({
    method: 'get',
    url: `/organization/api/xzqh/qgProvince/list`,
    data: data
})


/**
 * 修改角色资源通过角色类型
 * @param {*} data 
 * @returns 
 */
 export const updateRoleResByRoleType = (data) =>  request({
    method: 'put',
    url: `/organization/api/roleType/resource/edit`,
    data: data
})

/**
 * 获取角色类型的资源
 * @param {*} data 
 * @returns 
 */
 export const getRoleTypeResources = (roleType) =>  request({
    method: 'get',
    url: `/organization/api/roleType/resourceAll/${roleType}`
})


